import React, { useState, useRef, useEffect } from "react";
import {
  Collapse,
  Input,
  Button,
  Flex,
  Form,
  Switch,
  Typography,
} from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  LockOutlined,
} from "@ant-design/icons";
import globalData from "../../config/global_data";

const { Panel } = Collapse;
const { Text } = Typography;

const KitAttributeList = ({ setRemovedValues,setSavedattributes, customfielddata = null }) => {
  const [attributes, setAttributes] = useState([]);
   const [removedattributes, setRemovedattributes] = useState([]);
   
  const dragItem = useRef();
  const dragOverItem = useRef();

  useEffect(() => {
    const fetchData = async () => {
      let customdata = []

      if (customfielddata.custom_fields && customfielddata.custom_fields.length > 0) {
        customdata = customfielddata.custom_fields
      }
      if (customdata && globalData && globalData.attribute_tree.length > 0) {
        const mappedData = await globalData.attribute_tree.map((item, index) => {

          let value = [{}]
          const pattern = new RegExp(item.attri_pattern);

          const return_data = customdata.filter(initem => pattern.test(initem.name))

          for (let k = 0; k < return_data.length; k++) {
            const element = return_data[k];


            let indexvalue = element.name ? element.name.replace(/\D/g, '') : element.key.replace(/\D/g, '')
            indexvalue = indexvalue === "" ? 1 : indexvalue
            value[indexvalue - 1] = {
              val: element.value,
              key: element.id
            }
          }

          return ({
            name: item.name,
            values: value,
            max_size: item.max_size,
            min_size: item.min_size,
            is_required: item.is_required,
            attribute_element_type: item.attribute_element_type,
            attribute_key: item.attribute_key,
            id: item.id,
            store_id: item.store_id,
            info_text: item.info_text
          })
        })
        setAttributes(mappedData); // set api data       

      }
    };

    fetchData();
  }, [customfielddata]);

  useEffect(() => {

    setSavedattributes({ custom_fields: attributes });
  }, [attributes, setSavedattributes]);

  const handleSort = () => {
    const currentItem = attributes[dragItem.current];
    const updatedItems = [...attributes];
    updatedItems.splice(dragItem.current, 1);
    updatedItems.splice(dragOverItem.current, 0, currentItem);

    setAttributes(updatedItems);
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const addAttribute = () => {
    setAttributes([
      ...attributes,
      {
        name: `New Attribute ${attributes.length + 1}`,
        values: [""],
        isEditable: true,
      },
    ]);
  };

  const updateAttributeName = (index, newName) => {
    const updated = [...attributes];
    updated[index].name = newName;
    setAttributes(updated);
  };

  const updateValue = (attrIndex, valIndex, newValue) => {
    const updated = [...attributes];
    updated[attrIndex].values[valIndex] = newValue;
    setAttributes(updated);
  };

  const addValue = (attrIndex) => {
    const updated = [...attributes];
    updated[attrIndex].values.push("");
    setAttributes(updated);
  };

  const removeValue = (attrIndex, valIndex) => {
    const updated = [...attributes];
    updated[attrIndex].values.splice(valIndex, 1);
    setAttributes(updated);
  };

  const removeAttribute = (index) => {
    const updated = attributes.filter((_, i) => i !== index);
    setAttributes(updated);
  };
  const innerCollapseItems = attributes.map((attribute, index) => {
    const isDraggable = attribute.name !== "Primary Description";

    return {
      key: attribute.name,
      label: attribute.name,
      children: (
        <div
          className="panelname"
          {...(isDraggable && {
            draggable: true,
            onDragStart: () => (dragItem.current = index),
            onDragEnter: () => (dragOverItem.current = index),
            onDragEnd: handleSort,
            onDragOver: (e) => e.preventDefault(),
          })}
        >
          <Form.Item
            label={
              <span>
                Attribute Name&nbsp;
                {/* <QuestionCircleOutlined
                  style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                  title={attribute.info_text}
                /> */}
              </span>
            }
            style={{ marginBottom: 8 }}
            name={attribute.name}
          >
            <Input
              value={attribute.name}
              onChange={(e) => updateAttributeName(index, e.target.value)}
              placeholder={attribute.name}
              suffix={!attribute.isEditable && <LockOutlined />}
              disabled={!attribute.isEditable}
            />
          </Form.Item>

          {attribute.values.map((value, valIndex) => (
            <Form.Item
              key={valIndex}
              label={
                <span>
                  Value {valIndex + 1}&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                    title={attribute.info_text}
                  /> */}
                </span>
              }
              style={{ marginBottom: 8 }}
              // name="Attribute Value"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter Attribute Value",
              //   },
              // ]}
            >
              <Flex
                style={{
                  display: "flex",
                  paddingBottom: "20px",
                  width: "100%",
                }}
                align="start"
                size={8}
              >
                <div style={{ width: "100%" }}>
                  <Input.TextArea
                    value={value.val}
                    onChange={(e) =>
                      updateValue(index, valIndex, e.target.value, value.key)
                    }
                    maxLength={250}
                    style={{ width: "100%" }}
                    showCount={{
                      formatter: ({ count, maxLength }) =>
                        `${count}/${maxLength} characters`,
                    }}
                  />
                </div>
                {attribute.values.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => removeValue(index, valIndex)}
                    style={{ width: 32, padding: 0 }}
                  />
                )}
              </Flex>
            </Form.Item>
          ))}

          <div className="btnBox">
            <Button
              disabled={attribute.max_size <= attribute.values.length}
              onClick={() => addValue(index)}
              icon={<PlusOutlined />}
            >
              Add a value
            </Button>
          </div>

          <div className="SwitchBox">
            <Switch defaultChecked disabled/>
            <Text className="SwitchText">Visible on PDP</Text>
          </div>

          {attribute.isEditable && (
            <div className="btnBox btnRight">
              <Button
                type="primary"
                danger
                onClick={() => removeAttribute(index)}
                style={{ marginTop: 8, marginLeft: "auto" }}
                icon={<DeleteOutlined />}
              >
                Remove Attribute
              </Button>
            </div>
          )}
        </div>
      ),
    };
  });
  return (
    <Collapse
      defaultActiveKey={["product-page-details"]}
      items={[
        {
          key: "product-page-details",
          label: "Product page details",
          children: (
            <>
              <Collapse defaultActiveKey={["0"]} items={innerCollapseItems} />

             
            </>
          ),
        },
      ]}
    />
  );
};

export default KitAttributeList;
